import { NavLink } from 'react-router-dom';

export function InterventieBottomNav() {
  return (
    <nav className="fixed bottom-0 w-full min-h-[var(--nav-bottom-h)] bg-white border-t border-gray-200 lg:hidden z-50">
      <div className="flex justify-around pt-2 pb-[calc(0.5rem+env(safe-area-inset-bottom,0px))]">
        <NavLink
          to="/interventie"
          end
          className={({ isActive }) =>
            `flex flex-col items-center gap-0.5 min-h-[48px] justify-center px-4 ${isActive ? 'text-td-blue' : 'text-gray-400'}`
          }
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span className="text-[10px] font-medium">Mijn Interventies</span>
        </NavLink>
      </div>
    </nav>
  );
}
